var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('portal-target',{attrs:{"name":"offcanvas"}}),_c('portal-target',{attrs:{"name":"modal"}}),_c('portal-target',{attrs:{"name":"share-modal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }